<template>
    <div class="component-group" :class="{ header: isHeader, footer: isFooter, body: !isHeader && !isFooter }">
        <div v-if="title || ctaText" class="component-group-title">
            <div class="component-group__title">{{ title }}</div>
            <Cta v-if="ctaText" type="link" size="sm" :label="ctaText" :route="ctaRoute" :fitInline="true" @updateRoute="handleUpdateExterior"> </Cta>
        </div>

        <div v-for="(component, index) in components" :key="index" :class="[isHeader ? 'component-header-item' : 'component-item', { 'single-component': components.length === 1 }]">
	        <component :is="component.vueComponent" v-bind="component" :isDisabled="isDisabledGroup" @update-selection="handleUpdateSelection" @update-route="handleUpdateRoute" @update-route-back="handleUpdateRouteBack" />
        </div>
    </div>
</template>

<script>
import Selection from './Selection.vue';
import DoorFitFinderSelection from './DoorFitFinderSelection.vue';
import Cta from './shared/Cta.vue';
import QuickShip from './QuickShip.vue';
import Disclaimer from './Disclaimer.vue';
import StandardShipping from './StandardShipping.vue';
import ProductFinishes from './ProductFinishes.vue';
import Products from './Products.vue';
import ProductFilters from './ProductFilters.vue';
import ControlsFooter from './ControlsFooter.vue';
import CompatibilityModal from './shared/Modals/CompatibilityModal.vue';
import CtaFooter from './CtaFooter.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
    components: {
        Selection,
        DoorFitFinderSelection,
        Cta,
        QuickShip,
        StandardShipping,
        ProductFinishes,
        ControlsFooter,
        CtaFooter,
        Products,
        ProductFilters,
        Disclaimer,
    },
    name: 'ComponentGroup',
    props: {
        title: {
            type: String,
            default: '',
        },
        ctaText: {
            type: String,
            default: '',
        },
        ctaRoute: {
            type: String,
            default: '',
        },
        isHeader: {
            type: Boolean,
            default: false,
        },
        isFooter: {
            type: Boolean,
            default: false,
        },

        components: {
            type: Array,
            default: [],
        },
    },
    computed: {
        ...mapActions(['updateSelections', 'openModal']),
        ...mapGetters(['backToRoute', 'compatibilityModalProps']),
        isDisabledGroup() {
            return !!this.ctaRoute;
        },
    },
    emits: ['update-route', 'update-selection', 'update-route-back', 'update-filters'],
    methods: {
        async handleUpdateSelection(selection, ignoreCompatibility) {
            if (!ignoreCompatibility && !!selection?.selection?.compatibilityMessage) {
                await this.$store.dispatch('openModal', {
                    component: CompatibilityModal,
                    props: { categoryType: selection.selection.categoryType, handleContinueSelection: this.handleUpdateSelection, selection, compatibilityModalMessage: selection?.selection?.compatibilityModalMessage },
                });
                return;
            }
            await this.$emit('update-selection', selection);
        },
        // the componentGroup has a ctaRoute property for Interior/Exterior that we are using to toggle the view
        // if we have the ctaRoute property we are just going to update the view to be interior/exterior
        handleUpdateRoute(route) {
            if (this.isDisabledGroup) {
                this.handleUpdateExterior(this.ctaRoute);
            } else {
                this.$emit('update-route', route);
            }
        },

        handleUpdateRouteBack(route) {
            this.$emit('update-route-back', route);
        },
        async handleUpdateExterior(route) {
            let value = route === '/Outside';
            return await this.$emit('update-selection', { selection: value, fieldId: 'selections.exterior', optionChanged: 'None' });
        },
    },
};
</script>
